import resources from "constants/resources";
import { _post, _patch } from "./resources";
import { updatePageRow } from "./paginator";
import { capitalize } from "utils/string";

export const createList = (resource, payload) => ({
  type: "REQUEST_POST_LIST",
  resource,
  payload
});

export const updateList = (resource, payload) => ({
  type: "REQUEST_PATCH_LIST",
  resource,
  payload
});

export const deleteList = (resource, payload) => ({
  type: "REQUEST_DELETE_LIST",
  resource,
  payload
});

export const receiveCollectionList = (resource, payload) => ({
  type: "RECEIVE_POST_COLLECTION_LIST",
  resource,
  payload
});

const postList = _post(createList, receiveCollectionList);

const patchAndUpdate = _patch(updateList, updatePageRow);

const patchAndUpdate2 = _patch(updateList, updateList);

export const lists = {};

Object.keys(resources).forEach(key => {
  let resource = resources[key];

  lists["create" + capitalize(key)] = (payload = {}, id = null) => {
    let url = resource.url;
    if (id) {
      url = url + `/${id}`;
    }
    return postList(key, url, payload);
  };
  lists["patchAndUpdate" + capitalize(key) + "Page"] = (id = null, payload = {}) => {
    let url = resource.url;
    if (id) {
      url = url + `/${id}`;
    }
    return patchAndUpdate(key, url, payload);
  };
  lists["patchAndUpdate" + capitalize(key)] = (id = null, payload = {}) => {
    let url = resource.url;
    if (id) {
      url = url + `/${id}`;
    }
    return patchAndUpdate2(key, url, payload);
  }
});





// WEBPACK FOOTER //
// ./src/actions/lists.js